import { render } from "./LineDividerCmt.vue?vue&type=template&id=1c8bad03&scoped=true"
const script = {}

import "./LineDividerCmt.vue?vue&type=style&index=0&id=1c8bad03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8bad03"]])

export default __exports__